"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitAddToCartGa4Event = exports.emitViewItemGa4Event = void 0;
var emitViewItemGa4Event = function (variants, currency) {
    var _a;
    var items = variants.map(function (variant) { return ({
        item_id: buildItemId(variant.sku),
        item_name: buildGaItemName({ productTitle: variant.product.title, variantTitle: variant.title }),
        price: variant.price,
    }); });
    var data = {
        currency: currency,
        items: items,
    };
    (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'view_item', data);
};
exports.emitViewItemGa4Event = emitViewItemGa4Event;
/** https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#example_3 */
var emitAddToCartGa4Event = function (variants, value, currency) {
    var _a;
    var items = variants.map(function (variant) { return ({
        item_id: buildItemId(variant.sku),
        item_name: buildGaItemName({ productTitle: variant.product.title, variantTitle: variant.title }),
        price: variant.price,
        quantity: variant.quantity,
    }); });
    var data = {
        currency: currency,
        value: value,
        items: items,
    };
    (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'add_to_cart', data);
};
exports.emitAddToCartGa4Event = emitAddToCartGa4Event;
var buildGaItemName = function (_a) {
    var productTitle = _a.productTitle, variantTitle = _a.variantTitle;
    return "".concat(productTitle, " : ").concat(variantTitle);
};
var buildItemId = function (variantSku) {
    return variantSku.toUpperCase();
};
